module.exports = __webpack_public_path__ + "img/current-img-2.e96c03a0.png";